import React from "react";
import Sidebar from "@widgets/sidebar/Sidebar";
import BottomNavBar from "@shared/ui/bottom-nav-bar/BottomNavBar";
import TopInfoBar from "@shared/ui/top-info-bar/TopInfoBar"; // Nueva importación
import SupportTicket from "./support-ticket/SupportTicket";
import { useLayout } from "@app/providers/LayoutContext";
import { isDesktop, isMobile } from "react-device-detect";
import { isAuthenticated } from "../utils/authStorage";
import "./Layout.css";

const Navigation = ({
  isTabletDevice,
  isLandscape,
  isSidebarVisible,
  isBottomNavVisible,
  isCel,
}) => {
  const isAuth = isAuthenticated();
  if (!isAuth) return null;

  if (isTabletDevice) {
    if (isLandscape && isSidebarVisible) return <Sidebar />;
    if (!isLandscape && isBottomNavVisible) return <BottomNavBar />;
    return null;
  }

  if (isDesktop && !isCel && isSidebarVisible) return <Sidebar />;
  if ((isMobile || isCel) && !isTabletDevice && isBottomNavVisible)
    return <BottomNavBar />;
  return null;
};

const Layout = ({ children }) => {
  const {
    isSidebarVisible,
    isBottomNavVisible,
    isCel,
    isSidebarCollapsed,
    isTabletDevice,
    isLandscape,
  } = useLayout();

  // Verificar si se debe mostrar el TopInfoBar
  const shouldShowTopInfoBar = () => {
    if (!isAuthenticated()) return false;

    // Para tablets en modo vertical, mostrar TopInfoBar
    if (isTabletDevice && !isLandscape && isBottomNavVisible) {
      return true;
    }

    // Para móviles (no tablets)
    if ((isMobile || isCel) && !isTabletDevice && isBottomNavVisible) {
      return true;
    }

    return false;
  };

  return (
    <div className="layout-container">
      <Navigation
        isTabletDevice={isTabletDevice}
        isLandscape={isLandscape}
        isSidebarVisible={isSidebarVisible}
        isBottomNavVisible={isBottomNavVisible}
        isCel={isCel}
      />
      <div
        className={`layout-content 
          ${
            (isSidebarVisible && isDesktop && !isCel) ||
            (isTabletDevice && isLandscape && isSidebarVisible)
              ? isSidebarCollapsed
                ? "with-sidebar-collapsed"
                : "with-sidebar"
              : ""
          } 
          ${
            (isBottomNavVisible && (isMobile || isCel) && !isTabletDevice) ||
            (isTabletDevice && !isLandscape && isBottomNavVisible)
              ? "with-bottom-nav"
              : ""
          }
          ${shouldShowTopInfoBar() ? "with-top-info-bar" : ""}`}
      >
        {shouldShowTopInfoBar() && <TopInfoBar />}
        <div className="layout-content-inner">{children}</div>
      </div>
      <SupportTicket />
    </div>
  );
};

export default Layout;
